import { render, staticRenderFns } from "./SpecificationSectionLaborCreate.vue?vue&type=template&id=309fb049"
import script from "./SpecificationSectionLaborCreate.vue?vue&type=script&lang=js"
export * from "./SpecificationSectionLaborCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports